import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// --- SwiperJS Imports ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
// --- 1. EXPLICIT IMAGE IMPORTS (Only these 26 variables exist) ---
import InteriorImage5 from '../../../assets/Images/Interior5.jpg';
import InteriorImage9 from '../../../assets/Images/Interior9.jpg';
import InteriorImage11 from '../../../assets/Images/Interior11.jpg';
import InteriorImage15 from '../../../assets/Images/Interior15.jpg';
import InteriorImage16 from '../../../assets/Images/Interior16.jpg';
import InteriorImage19 from '../../../assets/Images/Interior19.jpg';
import InteriorImage20 from '../../../assets/Images/Interior20.jpg';
import InteriorImage24 from '../../../assets/Images/Interior24.jpg';
import InteriorImage25 from '../../../assets/Images/Interior25.jpg';
import InteriorImage33 from '../../../assets/Images/Interior33.jpg';
import InteriorImage34 from '../../../assets/Images/Interior34.jpg';
import InteriorImage37 from '../../../assets/Images/Interior37.jpg';
import InteriorImage46 from '../../../assets/Images/Interior46.jpg';
import InteriorImage49 from '../../../assets/Images/Interior49.jpg';
import InteriorImage55 from '../../../assets/Images/Interior55.jpg';
import InteriorImage56 from '../../../assets/Images/Interior56.jpg';
import InteriorImage58 from '../../../assets/Images/Interior58.jpg';
import InteriorImage64 from '../../../assets/Images/Interior64.jpg';
import InteriorImage70 from '../../../assets/Images/Interior70.jpg';
import InteriorImage71 from '../../../assets/Images/Interior71.jpg';
import InteriorImage72 from '../../../assets/Images/Interior72.jpg';
import InteriorImage75 from '../../../assets/Images/Interior75.jpg';
import InteriorImage77 from '../../../assets/Images/Interior77.jpg';
import InteriorImage78 from '../../../assets/Images/Interior78.jpg';
import InteriorImage79 from '../../../assets/Images/Interior79.jpg';
import InteriorImage80 from '../../../assets/Images/Interior80.jpg';


// --- Helper function to select random images for the Marquee ---
const allInteriorImages = [
    // Removed InteriorImage2, InteriorImage4, InteriorImage6, InteriorImage10, InteriorImage21, InteriorImage23, etc.
    InteriorImage5, 
    InteriorImage9, 
    InteriorImage11, 
    InteriorImage15, InteriorImage16, 
    InteriorImage19, InteriorImage20, 
    InteriorImage24, InteriorImage25, 
    InteriorImage33, InteriorImage34, InteriorImage37, 
    InteriorImage46, InteriorImage49, 
    InteriorImage55, InteriorImage56, 
    InteriorImage58, InteriorImage64, 
    InteriorImage70, InteriorImage71, InteriorImage72, 
    InteriorImage75, InteriorImage77, InteriorImage78, InteriorImage79, InteriorImage80, 
];

// Re-generate the marquee images based on the remaining set
// **FIXED LOGIC:** Directly maps the full list of imported images.
const marqueeSourceImages = allInteriorImages.map((imageSrc, i) => {
    return { 
        id: i, 
        src: imageSrc, 
        alt: `Interior Design Showcase ${i + 1}` 
    };
});



const MarqueeStyles = () => (
    <style>{`
        /* Custom styles for Red/Black/White theme */
        .text-gradient-red-black {
            background-image: linear-gradient(to right, #DC2626, #1F2937); /* Red and Dark Gray/Black */
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .btn-red-style { 
            border: 2px solid #DC2626; 
            color: #DC2626;
            padding: 0.75rem 2rem;
            text-transform: uppercase;
            font-weight: 600;
            transition: all 0.3s;
        }
        .btn-red-style:hover { 
            background-color: #DC2626; 
            color: white; 
        }
        
        /* SwiperJS Marquee Specific Styles */
        .interactive-marquee .swiper-slide {
            width: 300px; /* Slightly larger size for interior images */
            height: 350px;
        }
        .interactive-marquee .swiper-wrapper {
            transition-timing-function: linear !important;
        }
        .text-brand-red { color: #DC2626; }
        .text-brand-dark { color: #1F2937; }
    `}</style>
);


const DesignGallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    
    // Logic to handle scrollbar hiding and showing
    useEffect(() => {
        if (selectedImage) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [selectedImage]);


    return (
        <>
            <MarqueeStyles />
            <section id="design-gallery" className="container mx-auto px-6 py-24">
                
                {/* --- 1. Main Introduction Section --- */}
                <div className="grid md:grid-cols-2 gap-12 items-center mb-24"> 
                    {/* Replaced AnimateOnScroll with a simple div to maintain grid structure */}
                    <div>
                        <h2 className="text-5xl md:text-6xl headline-font text-gradient-red-black">Design Mastery: Transforming Concepts into Reality</h2>
                        <div className="w-24 bg-brand-red h-1 my-8"></div>
                        <Link to="/contact" className="btn btn-red-style">Start Your Project</Link>
                    </div>
                    {/* Replaced AnimateOnScroll with a simple div to maintain grid structure */}
                    <div>
                        <p className="text-lg">D'Red Interiors brings precision and passion to every space. We go beyond mere decoration to craft environments that enhance well-being and function seamlessly with your lifestyle. Our method blends meticulous technical planning with sophisticated, timeless aesthetics.</p>

                        <p className="mt-4 text-lg">We manage the process from initial 3D conceptualization to final installation, ensuring quality in every finish and fixture. Our goal is to translate your vision into a cohesive, high impact space that feels effortlessly yours.</p>

                        <p className="mt-4 text-lg">We specialize in various spaces: from contemporary residential interiors to high-efficiency commercial fit-outs. See how our <span className="font-semibold text-brand-red">custom millwork</span> and <span className="font-semibold text-brand-dark">smart lighting plans</span> define our commitment to excellence.</p>
                    </div>
                </div>

                {/* --- 2. Marquee Gallery Section --- */}
                {/* Replaced AnimateOnScroll with a simple div */}
                <div>
                    <h3 className="headline-font text-3xl mt-24 mb-8 text-gradient-red-black text-center">Interior Design Capabilities</h3> 
                    
                    <div className="mb-7"> 
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            grabCursor={true}
                            slidesPerView={'auto'}
                            spaceBetween={24}
                            // Speed set to 4000ms for a faster marquee
                            speed={1400} 
                            autoplay={{
                                delay: 0,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            className="interactive-marquee"
                        >
                            {marqueeSourceImages.map((image) => (
                                <SwiperSlide key={image.id}>
                                    <div 
                                        className="w-full h-full rounded-xl overflow-hidden shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
                                        onClick={() => setSelectedImage(image.src)}
                                    >
                                        <img src={image.src} className="w-full h-full object-cover" alt={image.alt}/>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* --- Image Enlargement Modal --- */}
            {selectedImage && (
                <div 
                    className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 cursor-pointer" 
                    onClick={() => setSelectedImage(null)}
                >
                    <button 
                        className="absolute top-5 right-5 text-white text-4xl font-bold cursor-pointer z-[90]"
                        onClick={() => setSelectedImage(null)}
                    >
                        &times;
                    </button>
                    <img 
                        src={selectedImage} 
                        alt="Enlarged design view" 
                        className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl cursor-default"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
};

export default DesignGallery;